import React from 'react';
import { useState, useEffect } from 'react';

import DialogContent from '@mui/material/DialogContent';
import { TextField, Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';


import ArticleGestionAutocomplete from 'components/Shared/ArticleGestionAutocomplete';

import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '100%',
        marginBottom: theme.spacing(1)
    },
}));



const GesteCommercialDialogContent = ({ onChange, action })  => {

    const classes = useStyles();

    const [codeArticle, setCodeArticle] = useState('');
    const [quantite, setQuantite] = useState(0);
    const [motif, setMotif] = useState('');


    useEffect(() => {
        onChange(null);
    }, [onChange]);


    useEffect(() => {


        const getActionData = () => {

            if (codeArticle === '') {
                return null;
            }
            if (quantite === 0) {
                return null;
            }
            if (motif === '') {
                return null;
            }

            let actionData =
            {
                code: action.code,
                details: [
                    {
                        code: ReclamationActionDetailCodes.CodeArticle,
                        type: ReclamationActionDetailType.Texte,
                        libelle: "Code article",
                        position: 0,
                        valeurString: codeArticle
                    },
                    {
                        code: ReclamationActionDetailCodes.Quantite,
                        type: ReclamationActionDetailType.Entier,
                        libelle: "Quantité",
                        position: 1,
                        valeurInteger: quantite
                    },
                    {
                        code: ReclamationActionDetailCodes.Memo,
                        type: ReclamationActionDetailType.Texte,
                        libelle: "Motif",
                        position: 2,
                        valeurString: motif
                    }],
                reponseAttendue: false // Afin de ne pas bloquer l'ajout de mémo
            };



            return actionData;
        }


        onChange(getActionData());
    }, [action.code, onChange, codeArticle, quantite, motif]);


    return (
        <DialogContent>

            <Typography variant="body1" gutterBottom>Effectuer cette action pour :</Typography>
            <Typography variant='body2' gutterBottom>Demander un gratuit auprès du DR</Typography>  

            <ArticleGestionAutocomplete
                onChange={(article) => { setCodeArticle(article.reference);}}
                required
            />

            <TextField
                className={classes.formControl}
                value={quantite}
                onChange={e => setQuantite(e.target.value)}
                variant={"filled"}
                label={"Quantité"}
                required
            />

            <TextField
                className={classes.formControl}
                value={motif}
                onChange={e => setMotif(e.target.value)}
                variant={"filled"}
                label={"Motif"}
                required
                multiline
            />


        </DialogContent>
    );

}


export default GesteCommercialDialogContent;